<template>
    <b-button size="sm" variant="outline-secondary" class="ml-1 extra-small" @click="confirmarTroca" :disabled="isLoading">
        <b-spinner v-if="isLoading" small class="align-middle"></b-spinner>
        <font-awesome-icon v-else icon="refresh" />
    </b-button>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ldiService from '@/services/licitacoes/ldiService'

const CompProps = Vue.extend({
    name: 'SeletorFracassadoItem',
    components: {},
    props: {
        itemLicitacao: {
            type: Object,
            required: true
        }
    },
})

@Component
export default class SeletorFracassadoItem extends CompProps {
    isLoading = false

    async confirmarTroca() {
        //console.log('itemLicitacao -> ', this.itemLicitacao)
        this.$bvModal.msgBoxConfirm(
            `Deseja ${this.itemLicitacao.FlFracassado === 'Não' ? 'fracassar' : 'desmarcar como fracassado'} o item ${this.itemLicitacao.DeItemMatServ}?`,
            {
                buttonSize: 'sm',
                cancelTitle: 'Não',
                cancelVariant: 'outline-secondary',
                centered: true,
                headerBgVariant: 'secondary',
                headerTextVariant: 'light',
                okTitle: 'Sim, alterar',
                title: 'Confirmar troca de situação',
            }
        ).then(async (value) => {
            //console.log('usuário respondeu', value)
            if (value) {
                this.isLoading = true
                const response = await ldiService.alterarItemFracassado(this.itemLicitacao)
                this.$emit('sitFracassoAtualizada', response)
            }
        }).catch(err => {
            console.error('Erro ao operar o dialog de alerta de troca de fracasso de item', err)
        }).finally(() => {
            this.isLoading = false
        })
    }
}
</script>